import React, { Component } from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import { BAR_COLORS } from './constants'
import { getMonthDateYearTimestampString, prettifyDuration } from 'helpers/DateUtil'

// Import Highcharts
import Highcharts from 'highcharts'

import highchartsGantt from 'highcharts/modules/gantt'
import HighchartsReact from 'highcharts-react-official'


highchartsGantt(Highcharts);

class DataChart extends Component {

  constructor(props){
    super(props)
    this.series = []
    this.calculateSeries(props)
  }

  shouldComponentUpdate(nextProps, nextState){
    /*if(this.props.history.length != nextProps.history.length){
      this.calculateSeries(nextProps)
      this.refs.chartComponent.chart.update({
        series: this.series
      }, true, true, false)
    }*/
    return false
  }

  calculateSeries(props){
    this.series = []
    props.history.forEach((entry, index) => {
      // Find existing row
      var indexInSeries = this.series.findIndex((row) => row.name === entry.state)
      var row;
      if(indexInSeries < 0){
        // If row doesn't exist, create new row
        row = {
          name: entry.state,
          duration: 0,
          data: [],
        }
        indexInSeries = this.series.length
        this.series.push(row)
      } else {
        // Use existing row
        row = this.series[indexInSeries]
      }

      // Create new data point
      const startDate = Date.parse(entry.startDate)
      const endDate = entry.endDate ? Date.parse(entry.endDate) : (new Date()).getTime()
      var rowData = {
        id: index,
        start: startDate,
        end: entry.endDate ? endDate : undefined,
        ongoing: entry.endDate === null,
        milestone: entry.endDate === null,
        initiatedBy: entry.createdByUserName,
        duration: Math.abs(endDate - startDate),
        revisionNumber: entry.revisionCount,
        y: indexInSeries
      }

      // Add duration of new data point to duration of row
      row.duration += rowData.duration
      // Add data point to row
      row.data.push(rowData)
    })
  }

  render(){
    return(
      <div styleName='chartContainer'>
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'ganttChart'}
            ref='chartComponent'
            options={{
              series: this.series,
              plotOptions: {
                series: {
                  pointPadding: 0,
                  groupPadding: 0,
                  pointWidth: 15
                }
              },
              yAxis: {
                lineColor: 'rgba(0,0,0,0.2)',
                type: 'category',
                grid: {
                  enabled: true,
                  borderWidth: 0,
                  borderColor: 'rgba(0,0,0,0.05)',
                  columns: [
                    { 
                      labels: {
                        padding: 5,
                        align: 'left', 
                        style: {
                          fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
                          fontWeight: '500'
                        }
                      },
                      categories: this.series.map((row) => row.name)
                    },
                    {
                      labels: {
                        padding: 5,
                        align: 'left', 
                        style: {
                          fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif'
                        }
                      },
                      categories: this.series.map((row) => prettifyDuration(row.duration))
                    }
                  ]
                }
              },
              xAxis: [
                {
                  visible: false,
                  maxPadding: 0.03
                },
                {
                  visible: false
                }
              ],
              tooltip: {
                formatter: function(){
                  return '<b>'+ this.point.yCategory + '</b><br/>Initiated by: ' + this.point.initiatedBy + '<br/>' +
                    'Started at: ' + getMonthDateYearTimestampString(new Date(this.point.start)) + '<br/>' +
                    'Finished at: ' + (this.point.ongoing ? 'Ongoing' : getMonthDateYearTimestampString(new Date(this.point.end))) + 
                    '<br/>Duration: ' + prettifyDuration(this.point.duration) + '<br/>Revision: ' + this.point.revisionNumber
                },
                outside: true,
                style: {
                  fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif'
                }
              },
              colors: BAR_COLORS,
              chart: {
                animation: false,
                height: this.series.length * 40
              },
              time: {
                timezoneOffset: new Date().getTimezoneOffset()
              },
              credits: {
                enabled: false
              }
            }}
          />
      </div>
    )
  }
}

export default CSSModules(styles)(DataChart)
